// Common
import commonIconLogoFull from '~/assets/icons/common_icon_logo_full.svg';
import commonIconEyeHidden from '~/assets/icons/common_icon_eye_hidden.svg';
import commonIconEyeShow from '~/assets/icons/common_icon_eye_show.svg';
import commonIconAddress from '~/assets/icons/common_icon_address.svg';
import commonIconAddressNew from '~/assets/icons/common_icon_address_new.svg';
import commonIconEmail from '~/assets/icons/common_icon_email.svg';
import commonIconPhone from '~/assets/icons/common_icon_phone.svg';
import commonIconUser from '~/assets/icons/common_icon_user.svg';
import commonIconCallPhone from '~/assets/icons/common_icon_call_phone.svg';
import commonIconNotification from '~/assets/icons/common_icon_notification.svg';
import commonIconPlus from '~/assets/icons/common_icon_plus.svg';
import commonIconPlusGrey from '~/assets/icons/common_icon_plus_grey.svg';
import commonIconMinus from '~/assets/icons/common_icon_minus.svg';
import commonIconGoogle from '~/assets/icons/common_icon_google.svg';
import commonIconStarUnactive from '~/assets/icons/common_icon_star_unactive.svg';
import commonIconStarActive from '~/assets/icons/common_icon_star_active.svg';
import commonIconInputSearch from '~/assets/icons/common_icon_input_search.svg';
import commonIconNextPrimary from '~/assets/icons/common_icon_next_primary.svg';
import commonIconNext from '~/assets/icons/common_icon_next.svg';
import commonIconNextActive from '~/assets/icons/common_icon_next_active.svg';
import commonIconPreviousPrimary from '~/assets/icons/common_icon_prev_primary.svg';
import commonIconPrevious from '~/assets/icons/common_icon_prev.svg';
import commonIconPreviousActive from '~/assets/icons/common_icon_prev_active.svg';
import commonIconUncheckbox from '~/assets/icons/common_icon_uncheckbox.svg';
import commonIconCheckbox from '~/assets/icons/common_icon_checkbox.svg';
import commonIconIndeterminate from '~/assets/icons/common_icon_indeterminate.svg';
import commonIconSaveDraft from '~/assets/icons/common_icon_save_draft.svg';
import commonIconSendQuote from '~/assets/icons/common_icon_send_quote.svg';
import commonIconQuoteItems from '~/assets/icons/common_icon_quote_items.svg';
import commonIconPlusPrimary from '~/assets/icons/common_icon_plus_primary.svg';
import commonIconTrash from '~/assets/icons/common_icon_trash.svg';
import commonIconTrashDisable from '~/assets/icons/common_icon_trash_disable.svg';
import commonIconTrashRed from '~/assets/icons/common_icon_trash_red.svg';
import commonIconTrashGrey from '~/assets/icons/common_icon_trash_grey.svg';
import commonIconAddFile from '~/assets/icons/common_icon_add_file.svg';
import commonIconArrowBottom from '~/assets/icons/common_icon_arrow_bottom.svg';
import commonIconArrowBottomOutline from '~/assets/icons/common_icon_arrow_bottom_outline.svg';
import commonIconArrowBottomFilter from '~/assets/icons/common_icon_arrow_bottom_filter.svg';
import commonIconArrowBottomWhite from '~/assets/icons/common_icon_arrow_bottom_white.svg';
import commonIconNote from '~/assets/icons/common_icon_note.svg';
import commonIconMenu from '~/assets/icons/common_icon_menu.svg';
import commonIconCalendar from '~/assets/icons/common_icon_calendar.svg';
import commonIconClock from '~/assets/icons/common_icon_clock.svg';
import commonIconSearch from '~/assets/icons/common_icon_search.svg';
import commonIconClose from '~/assets/icons/common_icon_close.svg';
import commonIconCancel from '~/assets/icons/common_icon_cancel.svg';
import commonIconRemove from '~/assets/icons/common_icon_remove.svg';
import commonIconClient from '~/assets/icons/common_icon_client.svg';
import commonIconEventDetails from '~/assets/icons/common_icon_event_details.svg';
import commonIconEventTimeLine from '~/assets/icons/common_icon_event_time_line.svg';
import commonIconRepeatBusiness from '~/assets/icons/common_icon_repeat_business.svg';
import commonIconReferralSource from '~/assets/icons/common_icon_referral_source.svg';
import commonIconAttachments from '~/assets/icons/common_icon_attachments.svg';
import commonIconUploadFile from '~/assets/icons/common_icon_upload_file.svg';
import commonIconUploadFileWhite from '~/assets/icons/common_icon_upload_file_white.svg';
import commonIconUploadPhoto from '~/assets/icons/common_icon_upload_photo.svg';
import commonIconFile from '~/assets/icons/common_icon_file.svg';
import commonIconUploadFileImage from '~/assets/icons/common_icon_upload_file_image.svg';
import commonIconUploadFileDocument from '~/assets/icons/common_icon_upload_file_document.svg';
import commonIconTime from '~/assets/icons/common_icon_time.svg';
import commonIconBack from '~/assets/icons/common_icon_back.svg';
import commonIconBackSchedule from '~/assets/icons/common_icon_back_schedule.svg';
import commonIconAddNote from '~/assets/icons/common_icon_add_note.svg';
import commonIconAddNoteActive from '~/assets/icons/common_icon_add_note_active.svg';
import commonIconItemDay from '~/assets/icons/common_icon_item_day.svg';
import commonIconCheckMark from '~/assets/icons/common_icon_check_mark.svg';
import commonIconStatusIndicator from '~/assets/icons/common_icon_status_indicator.svg';
import commonIconFileDocument from '~/assets/icons/common_icon_file_document.svg';
import commonIconDropdown from '~/assets/icons/common_icon_dropdown.svg';
import commonIconPickColor from '~/assets/icons/common_icon_pick_color.svg';
import commonIconChangeColor from '~/assets/icons/common_icon_change_color.svg';
import commonIconAddPrimary from '~/assets/icons/common_icon_add_primary.svg';
import commonIconPayment from '~/assets/icons/common_icon_payment.svg';
import commonIconClockTime from '~/assets/icons/common_icon_clock_time.svg';
import commonIconPerson from '~/assets/icons/common_icon_person.svg';
import commonIconSettingBlack from '~/assets/icons/common_icon_setting_black.svg';
import commonIconSettingRed from '~/assets/icons/common_icon_setting_red.svg';
import commonIconCompany from '~/assets/icons/common_icon_company.svg';
import commonIconHome from '~/assets/icons/common_icon_home.svg';
import commonIconJob from '~/assets/icons/common_icon_job.svg';
import commonIconLocation from '~/assets/icons/common_icon_location.svg';
import commonIconMall from '~/assets/icons/common_icon_mall.svg';
import commonIconPhoneNumber from '~/assets/icons/common_icon_phone_number.svg';
import commonIconPhoneNumberSmall from '~/assets/icons/common_icon_phone_number_small.svg';
import commonIconProfileSmall from '~/assets/icons/common_icon_profile_small.svg';
import commonIconProfile from '~/assets/icons/common_icon_profile.svg';
import commonIconSuite from '~/assets/icons/common_icon_suite.svg';
import commonIconPen from '~/assets/icons/common_icon_pen.svg';
import commonIconEditVariant from '~/assets/icons/common_icon_edit_variant.svg';
import commonIconCurrency from '~/assets/icons/common_icon_currency.svg';
import commonIconPaymentFee from '~/assets/icons/common_icon_payment_fee.svg';
import commonIconSetting from '~/assets/icons/common_icon_setting.svg';
import commonIconFilter from '~/assets/icons/common_icon_filter.svg';
import commonIconExportExcel from '~/assets/icons/common_icon_export_excel.svg';
import commonIconWarningError from '~/assets/icons/common_icon_warning_error.svg';
import commonIconTickActive from '~/assets/icons/common_icon_tick_active.svg';
import commonIconTick from '~/assets/icons/common_icon_tick.svg';
import commonIconCloseRed from '~/assets/icons/common_icon_close_red.svg';
import commonIconSuccess from '~/assets/icons/common_icon_success.svg';
import commonIconError from '~/assets/icons/common_icon_error.svg';
import commonIconPie from '~/assets/icons/common_icon_pie.svg';
import commonIconDelivery from '~/assets/icons/common_icon_delivery.svg';
import commonIconPickup from '~/assets/icons/common_icon_pickup.svg';
import commonIconPositionTruck from '~/assets/icons/common_icon_position_truck.svg';
import commonIconExport from '~/assets/icons/common_icon_export.svg';
import commonIconPrint from '~/assets/icons/common_icon_print.svg';
import commonIconClone from '~/assets/icons/common_icon_clone.svg';
import commonIconCloseRedNoBg from '~/assets/icons/common_icon_close_no_bg.svg';

// Menu
import menuIconDashboardActive from '~/assets/icons/menu_icon_dashboard_active.svg';
import menuIconDashboardUnactive from '~/assets/icons/menu_icon_dashboard_unactive.svg';
import menuIconCrmActive from '~/assets/icons/menu_icon_crm_active.svg';
import menuIconCrmUnactive from '~/assets/icons/menu_icon_crm_unactive.svg';
import menuIconJobsActive from '~/assets/icons/menu_icon_jobs_active.svg';
import menuIconJobsUnactive from '~/assets/icons/menu_icon_jobs_unactive.svg';
import menuIconCommunicationActive from '~/assets/icons/menu_icon_communication_active.svg';
import menuIconCommunicationUnactive from '~/assets/icons/menu_icon_communication_unactive.svg';
import menuIconQuotesActive from '~/assets/icons/menu_icon_quotes_active.svg';
import menuIconQuotesUnactive from '~/assets/icons/menu_icon_quotes_unactive.svg';
import menuIconSettingActive from '~/assets/icons/menu_icon_setting_active.svg';
import menuIconSettingUnactive from '~/assets/icons/menu_icon_setting_unactive.svg';
import menuIconUserAction from '~/assets/icons/menu_icon_user_active.svg';
import menuIconUserUnaction from '~/assets/icons/menu_icon_user_unactive.svg';
import menuIconInventoryActive from '~/assets/icons/menu_icon_inventory_active.svg';
import menuIconInventoryInactive from '~/assets/icons/menu_icon_inventory_inactive.svg';
import menuIconScheduleActive from '~/assets/icons/menu_icon_schedule_active.svg';
import menuIconScheduleUnactive from '~/assets/icons/menu_icon_schedule_unactive.svg';
import menuIconVehicleInactive from '~/assets/icons/menu_common_icon_vehicle_inactive.svg';
import menuIconVehicleActive from '~/assets/icons/menu_common_icon_vehicle_active.svg';
import menuIconTruckInActive from '~/assets/icons/menu_common_icon_truck_inactive.svg';
import menuIconTruckActive from '~/assets/icons/menu_common_icon_truck_active.svg';
import menuIconEquipmentInActive from '~/assets/icons/menu_common_icon_equipment_inactive.svg';
import menuIconEquipmentActive from '~/assets/icons/menu_common_icon_equipment_inactive.svg';
import menuIconTrailerInActive from '~/assets/icons/menu_common_trailer_inactive.svg';
import menuIconTrailerActive from '~/assets/icons/menu_common_trailer_inactive.svg';
import menuIconTaskInActive from '~/assets/icons/menu_icon_task_inactive.svg';
import menuIconTaskActive from '~/assets/icons/menu_icon_task_active.svg';
import menuIconVendorsActive from '~/assets/icons/menu_icon_vendor_active.svg';
import menuIconVendorsInactive from '~/assets/icons/menu_icon_vendor_inactive.svg';
import menuIconPurchaseActive from '~/assets/icons/menu_icon_purchase_order_active.svg';
import menuIconPurchaseInactive from '~/assets/icons/menu_icon_purchase_order_inactive.svg';
import menuIconOrderActive from '~/assets/icons/menu_icon_order_active.svg';
import menuIconOrderInactive from '~/assets/icons/menu_icon_order_inactive.svg';
import menuIconLogout from '~/assets/icons/menu_icon_logout.svg';
import menuIconUser from '~/assets/icons/menu_icon_user.svg';
import menuIconRole from '~/assets/icons/menu_icon_role_management.svg';
import menuIconCoupons from '~/assets/icons/menu_icon_coupons.svg';
import menuIconEventTypes from '~/assets/icons/menu_icon_event_types.svg';
import menuIconCategories from '~/assets/icons/menu_icon_categories.svg';
import menuIconInvoiceActive from '~/assets/icons/menu_icon_invoice_active.svg';
import menuIconInvoiceInactive from '~/assets/icons/menu_icon_invoice_inactive.svg';
import menuIconReportActive from '~/assets/icons/menu_icon_report_active.svg';
import menuIconReportUnactive from '~/assets/icons/menu_icon_report_unactive.svg';
import menuIconGoal from '~/assets/icons/menu_icon_goal.svg';
import menuIconChecklist from '~/assets/icons/menu_icon_checklist.svg';
import menuIconVenue from '~/assets/icons/menu_icon_venue.svg';

// Table
import tableIconMenuDots from '~/assets/icons/table_icon_menu_dots.svg';
import tableIconActionView from '~/assets/icons/table_icon_action_view.svg';
import tableIconActionSend from '~/assets/icons/table_icon_action_send.svg';
import tableIconActionEdit from '~/assets/icons/table_icon_action_edit.svg';
import tableIconActionDelete from '~/assets/icons/table_icon_action_delete.svg';
import tableIconActionActivate from '~/assets/icons/table_icon_action_activate.svg';

// Statistic
import statisticIconRevenue from '~/assets/icons/statistic_icon_revenue.svg';
import statisticIconUp from '~/assets/icons/statistic_icon_up.svg';
import statisticIconQuoteRequest from '~/assets/icons/statistic_icon_quote_request.svg';
import statisticIconActionItems from '~/assets/icons/statistic_icon_action_items.svg';
import statisticIconNotFinalized from '~/assets/icons/statistic_icon_not_finalized.svg';

// Conversation
import conversationIconFileDefault from '~/assets/icons/conversation_icon_file_default.svg';
import conversationIconStatusSent from '~/assets/icons/conversation_icon_status_sent.svg';
import conversationIconStatusDelivered from '~/assets/icons/conversation_icon_status_delivered.svg';
import conversationIconStatusSeen from '~/assets/icons/conversation_icon_status_seen.svg';

// Reports
import reportIconInventoryUsage from '~/assets/icons/report_icon_inventory_usage.svg';
import reportIconOverbookingItems from '~/assets/icons/report_icon_overbooking_items.svg';
import reportIconSubrental from '~/assets/icons/report_icon_subrental.svg';
import reportIconQuarantine from '~/assets/icons/report_icon_quarantine.svg';
import reportIconClientIncome from '~/assets/icons/report_icon_client_income.svg';
import reportIconRevenue from '~/assets/icons/report_icon_revenue.svg';
import reportIconGeographicRevenue from '~/assets/icons/report_icon_geographic_revenue.svg';
import reportIconOrderRevenue from '~/assets/icons/report_icon_order_revenue.svg';
import reportIconCancellations from '~/assets/icons/report_icon_cancellations.svg';
import reportIconSchedule from '~/assets/icons/report_icon_schedule.svg';
import reportIconDeliveryPickup from '~/assets/icons/report_icon_delivery_pickup.svg';
import reportIconForemanTasks from '~/assets/icons/report_icon_foreman_tasks.svg';
import reportIconForemanTaskCompletion from '~/assets/icons/report_icon_foreman_task_completion.svg';
import reportIconMarketingRevenue from '~/assets/icons/report_icon_marketing_revenue.svg';

const icons = {
  // Common
  commonIconLogoFull,
  commonIconEyeHidden,
  commonIconEyeShow,
  commonIconAddress,
  commonIconAddressNew,
  commonIconEmail,
  commonIconPhone,
  commonIconUser,
  commonIconCallPhone,
  commonIconNotification,
  commonIconPlus,
  commonIconGoogle,
  commonIconStarActive,
  commonIconStarUnactive,
  commonIconInputSearch,
  commonIconNextPrimary,
  commonIconNext,
  commonIconNextActive,
  commonIconPreviousPrimary,
  commonIconPrevious,
  commonIconPreviousActive,
  commonIconUncheckbox,
  commonIconCheckbox,
  commonIconIndeterminate,
  commonIconSaveDraft,
  commonIconSendQuote,
  commonIconQuoteItems,
  commonIconPlusPrimary,
  commonIconTrash,
  commonIconTrashDisable,
  commonIconAddFile,
  commonIconPlusGrey,
  commonIconMinus,
  commonIconArrowBottom,
  commonIconDropdown,
  commonIconArrowBottomOutline,
  commonIconArrowBottomFilter,
  commonIconArrowBottomWhite,
  commonIconNote,
  commonIconClose,
  commonIconCancel,
  commonIconMenu,
  commonIconCalendar,
  commonIconClock,
  commonIconSearch,
  commonIconRemove,
  commonIconClient,
  commonIconEventDetails,
  commonIconEventTimeLine,
  commonIconRepeatBusiness,
  commonIconReferralSource,
  commonIconAttachments,
  commonIconUploadFile,
  commonIconFile,
  commonIconUploadFileImage,
  commonIconUploadFileDocument,
  commonIconTrashGrey,
  commonIconTime,
  commonIconTrashRed,
  commonIconBack,
  commonIconBackSchedule,
  commonIconUploadPhoto,
  commonIconAddNote,
  commonIconAddNoteActive,
  commonIconItemDay,
  commonIconCheckMark,
  commonIconStatusIndicator,
  commonIconFileDocument,
  commonIconPickColor,
  commonIconChangeColor,
  commonIconAddPrimary,
  commonIconSettingBlack,
  commonIconSettingRed,
  commonIconCompany,
  commonIconHome,
  commonIconJob,
  commonIconLocation,
  commonIconMall,
  commonIconPhoneNumber,
  commonIconPhoneNumberSmall,
  commonIconProfileSmall,
  commonIconProfile,
  commonIconSuite,
  commonIconPen,
  commonIconEditVariant,
  commonIconPayment,
  commonIconClockTime,
  commonIconPerson,
  commonIconUploadFileWhite,
  commonIconCurrency,
  commonIconPaymentFee,
  commonIconSetting,
  commonIconFilter,
  commonIconExportExcel,
  commonIconWarningError,
  commonIconTick,
  commonIconTickActive,
  commonIconCloseRed,
  commonIconSuccess,
  commonIconError,
  commonIconPie,
  commonIconDelivery,
  commonIconPickup,
  commonIconPositionTruck,
  commonIconExport,
  commonIconPrint,
  commonIconClone,
  commonIconCloseRedNoBg,

  // Menu
  menuIconDashboardActive,
  menuIconDashboardUnactive,
  menuIconCrmActive,
  menuIconCrmUnactive,
  menuIconJobsActive,
  menuIconJobsUnactive,
  menuIconCommunicationActive,
  menuIconCommunicationUnactive,
  menuIconQuotesActive,
  menuIconQuotesUnactive,
  menuIconSettingActive,
  menuIconSettingUnactive,
  menuIconUserAction,
  menuIconUserUnaction,
  menuIconInventoryActive,
  menuIconInventoryInactive,
  menuIconScheduleActive,
  menuIconScheduleUnactive,
  menuIconVehicleInactive,
  menuIconVehicleActive,
  menuIconTruckActive,
  menuIconTruckInActive,
  menuIconTaskInActive,
  menuIconTaskActive,
  menuIconEquipmentActive,
  menuIconEquipmentInActive,
  menuIconTrailerActive,
  menuIconTrailerInActive,
  menuIconVendorsActive,
  menuIconVendorsInactive,
  menuIconPurchaseActive,
  menuIconPurchaseInactive,
  menuIconOrderActive,
  menuIconOrderInactive,
  menuIconReportActive,
  menuIconReportUnactive,
  menuIconLogout,
  menuIconUser,
  menuIconRole,
  menuIconCoupons,
  menuIconEventTypes,
  menuIconCategories,
  menuIconInvoiceActive,
  menuIconInvoiceInactive,
  menuIconGoal,
  menuIconChecklist,
  menuIconVenue,

  // Table
  tableIconMenuDots,
  tableIconActionView,
  tableIconActionSend,
  tableIconActionEdit,
  tableIconActionDelete,
  tableIconActionActivate,

  // Statistic
  statisticIconRevenue,
  statisticIconQuoteRequest,
  statisticIconActionItems,
  statisticIconNotFinalized,
  statisticIconUp,

  // Conversation
  conversationIconFileDefault,
  conversationIconStatusSent,
  conversationIconStatusDelivered,
  conversationIconStatusSeen,

  // Report
  reportIconInventoryUsage,
  reportIconOverbookingItems,
  reportIconSubrental,
  reportIconQuarantine,
  reportIconClientIncome,
  reportIconRevenue,
  reportIconGeographicRevenue,
  reportIconOrderRevenue,
  reportIconCancellations,
  reportIconSchedule,
  reportIconDeliveryPickup,
  reportIconForemanTasks,
  reportIconForemanTaskCompletion,
  reportIconMarketingRevenue,
};

export default icons;
